function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.2351 15.4437C21.251 14.3451 22.9004 12.8803 23.8167 10.9577L24 10.5915L23.8167 10.1338C21.9841 6.47183 17.494 4 12.5458 4C10.8964 4 9.33865 4.27465 7.87251 4.73239L5.76494 5.64789C3.749 6.74648 2.0996 8.21127 1.18327 10.1338L1 10.5L1.18327 10.8662C3.01594 14.5282 7.50598 17 12.4542 17C14.1036 17 15.6614 16.7254 17.1275 16.2676C19.2351 15.5352 19.2351 15.4437 19.2351 15.4437Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.5 14C14.433 14 16 12.433 16 10.5C16 8.567 14.433 7 12.5 7C10.567 7 9 8.567 9 10.5C9 12.433 10.567 14 12.5 14Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1 1L23.4502 19",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var SvgEyeClosed = function SvgEyeClosed(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "transparent",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEyeClosed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye-closed.a06b670f.svg";
export { ForwardRef as ReactComponent };